import React, {Component} from 'react';
import { Badge,  Row, Col, InputGroup, InputGroupAddon, InputGroupButton,  Fade, Input, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, 
  Card, CardBody, CardHeader, Form, FormGroup,  FormFeedback } from 'reactstrap';
import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import GroupIcon from '@material-ui/icons/ShortText';
import TextField from '@material-ui/core/TextField';
import Rating from 'react-rating';
import VisualClipComponent from './VisualClipComponent';
import '../../../node_modules/font-awesome/css/font-awesome.min.css'; 
import settings from '../../settings';
import Swal from 'sweetalert2';
import CheckBoxTrueFalse from './CheckBoxTrueFalse';
import MultiSelectView from './MultiSelectView';
import CorrectView from './CorrectView';
import VisualPictureComponent from './VisualPictureComponent';
import RadioGroupTrueFalse from './RadioGroupTrueFalse';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import fullballoon from '../../assets/images/RemaxBalloon32x41.png';
import emptyballoon from '../../assets/images/RemaxBalloon32x41_empty.png';
import '../../i18n'
import { withTranslation } from 'react-i18next'


const styles = theme => ({
  fab: {
    margin: theme.spacing.unit,    
    margin: 0,
    background: '#000000',
    position: 'absolute',
    top: '30%',
    left: '50%',
    marginright: '-50%',
    transform: 'translate(-50%, -50%)', 
    
  },
  extendedIcon: {
    marginRight: theme.spacing.unit,
  },
});

class Questionaire extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false, 
      rating: [], // holds starquestions + ratings { text: questionname, value: starcount }
      openquestionanswers: [], // holds openquestions + answers { text: question, value: answer}
      ssmsquestions: [], 
      solution: false, // is used for modal-button if solution false than button is disabled
      isCorrectViewVisible: true, // switch between visible CorrectView-Modal or not
      beantwortung: true, // is the enable-button for Beantwortung
      mode: 'nochnichtbeantwortet'
    };

  this.toggle = this.toggle.bind(this);
  this.closeModal = this.closeModal.bind(this);

  this.starCallback = this.starCallback.bind(this)
  this.openQuestionCallback = this.openQuestionCallback.bind(this)
  this.changeRating = this.changeRating.bind(this)
 // this.getValues = this.getValues.bind(this)
  this.setAnswerToSSQuestion = this.setAnswerToSSQuestion.bind(this)
  this.setAnswerToMSQuestion = this.setAnswerToMSQuestion.bind(this)
  this.ssCallback = this.ssCallback.bind(this)
  this.msCallback = this.msCallback.bind(this)

  }


  async componentDidMount(props){
   
    var localratingvalues = []
    if (this.props.starquestions && this.props.starquestions.length > 0) {
      this.props.starquestions.map( element => (
        localratingvalues.push({ text: element.question, value: 0 , id: element.id })
      ))
    }


    var localopenquestionanswers = []
    if (this.props.openquestions && this.props.openquestions.length > 0) {
      this.props.openquestions.map( element => (
        localopenquestionanswers.push({ text: element.question, value: '', id: element.id })
      ))
    }



    var localssmsquestions = []

    if (this.props.ssmsquestions && this.props.ssmsquestions.length > 0) {
      localssmsquestions = this.props.ssmsquestions
    }


    await this.setState({
      rating: localratingvalues, 
      openquestionanswers: localopenquestionanswers, 
      ssmsquestions: localssmsquestions
    })

 //   console.log('in componentWillReceiveProps', this.state)

  }

  toggle(e) {
	    	  	  
    this.setState({
      modal: !this.state.modal
    });

    if (this.state.modal) window.location.reload(); 
  }






  closeModal(e){
/*
    this.setState({
      rating: [], // holds starquestions + ratings { text: questionname, value: starcount }
      openquestionanswers: [], // holds openquestions + answers { text: question, value: answer}
      ssmsquestions: [], 
      solution: false, // is used for modal-button if solution false than button is disabled
      beantwortung: true, // is the enable-button for Beantwortung   
           
    })
    */
   // window.location.reload();
   //window.open(window.location, '_self').close()

   this.setState({
     mode: 'beantwortet'
   })

   // this.toggle();

   }

  async starCallback(starquestion){

      await this.setState({
        starquestions: starquestion
      })

  }

  async openQuestionCallback(openquestion){

    await this.setState({
      openquestions: openquestion
    })

}

changeRating( questiontext, rating ) {
//  console.log(' ratingvalues: ', this.state.rating)

  var localrating = this.state.rating;
  localrating.find( f => f.text == questiontext).value = rating;

  this.setState({
    rating: localrating
  });

}


getInitialRating(question){
  return this.state.rating.length < 1 ? 0 : this.state.rating.find(f=>f.text == question).value
}



changeOpenQuestion( questiontext, answer ) {

  var localquestion = this.state.openquestionanswers;
  localquestion.find( f => f.text == questiontext).value = answer.target.value;

  this.setState({
    openquestionanswers: localquestion
  });

}


generateJSON(){

var localstaranswers =[] 
this.state.rating.map( element => {
  localstaranswers.push({ id: element.id, stars: element.value})
})

var localopenanswers =[] 
this.state.openquestionanswers.map( element => {
  localopenanswers.push({ id: element.id, answer: element.value})
})

var localssmsanswers = []

this.state.ssmsquestions.map( element => {

  

  if (element.qtype == "ss") { localssmsanswers.push({ id: element.id, answer: element.answers })}

  if (element.qtype == "ms") {
    element.answers.map( e => {
    localssmsanswers.push({ id: element.id, aid: e.id, answers: e.answers })
    })
      
      }
}
)


var localJSON = {
  starAnswers: localstaranswers, 
  openAnswers: localopenanswers, 
  ssmsAnswers: localssmsanswers
}

//console.log('SSMS ANSWERS ARE: ', JSON.stringify(localJSON))


return JSON.stringify(localJSON)

  }


checkAnsweredQuestionsContainsEmptyValue(questiontype){


  if (questiontype == 'star') 
    if (this.state.rating.length > 0 )
      return this.state.rating.find( f => f.value == 0 ) ?  true : false;
    else return false
  
  if (questiontype == 'openquestion') 
    if (this.state.openquestionanswers.length > 0 )
      return this.state.openquestionanswers.find( f => f.value == '' ) ?  true : false;
    else return false
  

}



async postSurveyAnswerToJoobsterServer(){
 
  const {t} = this.props; 

 // if (this.checkAnsweredQuestionsContainsEmptyValue('star') == true || this.checkAnsweredQuestionsContainsEmptyValue('openquestion') == true )
   if (this.checkAnsweredQuestionsContainsEmptyValue('star') == true )

  {
    Swal.fire({
      title: t('questionaire.postsurvey.errortitle'),
      position: 'center',
      text: t('questionaire.postsurvey.errortextnotallquestions'),
      type: 'error',
      animation: true,
      customClass: {
        popup: 'animated tada'
      },       
      showConfirmButton: false, 
      timer: 1500
      //confirmButtonText: 'Cool'
    }) 		
    
    return null;
  }


  var answersJSON = this.generateJSON();

  await   fetch(settings.internalsurveypath + '/' + this.props.urlhash ,  {
       method: 'POST',
       headers: {
       'Content-Type': 'application/json',
       //'Authorization' : 'Bearer ' + this.props.auth.sessionId
       
       },
       body: answersJSON
     }).then((res) => res.json())
     .then( async (data) => { 
   
       console.log('data is: ', data)
 
 
       Swal.fire({
         position: 'top-end',
         type: 'success',
         title: t('questionaire.postsurvey.success'),
         showConfirmButton: false,
         timer: 2500
       })   		
     })
     .catch((err)=>{
       Swal.fire({
         title: t('questionaire.postsurvey.errortitle'),
         position: 'center',
         text: t('questionaire.postsurvey.errortransfer'),
         type: 'error',
         animation: true,
         customClass: {
           popup: 'animated tada'
         },       
         showConfirmButton: false, 
         timer: 2500
         //confirmButtonText: 'Cool'
       }) 		
     });	  
   
   //  this.closeModal();

   this.setState({
    solution: true,  // set Button "Lösung" enabled
    beantwortung: false,    
  }) 
   
  this.closeModal()
   }


   setAnswerToMSQuestion(indexquestion, indexmcquestion, val){ // indexquestion = general question , indexcquestion = element of multiselectquestion, val = value true/false

    this.state.ssmsquestions.filter( f => f.index == indexquestion)[0].answers.filter( f => f.index == indexmcquestion)[0].answers = [val]

   }

   async setAnswerToSSQuestion(index, val){ // indexquestion = general question , indexcquestion = element of multiselectquestion

      this.state.ssmsquestions.filter( f => f.index == index)[0].answers = [val]

      
/*      await this.setState({

      })
      */

   }


   ssCallback(element){
     this.setAnswerToSSQuestion(element.index, element.val)
   }

   msCallback(element){
     this.setAnswerToMSQuestion(element.index, element.subitemindex, element.val)
   }


   answerExistsForSSMS(){

    var valuecounter = 0;
    this.state.ssmsquestions.map( question => {
      if (question.qtype == "ss")
        if (question.answer != [] ) valuecounter++
      if (question.qtype == "ms")
         question.answers && question.answers.length > 0 && question.answers.map( subitem => {
           if (subitem.answer != []) valuecounter++
         }
         )
    })

   // console.log('ARE THERE ANSWERS BEHIND? ', valuecounter)
    if (valuecounter > 0) return true
    else return false
   }
  


  render() {
	  	  	  	  
    const { classes,t  } = this.props;
    const localthis = this;
    var ReactFitText = require('react-fittext');

    var emptySymbol=['fa fa-star-o fa-2x low', 'fa fa-star-o fa-2x low',
    'fa fa-star-o fa-2x medium', 'fa fa-star-o fa-2x medium',
    'fa fa-star-o fa-2x high', 'fa fa-star-o fa-2x high']
    var fullSymbol=['fa fa-star fa-2x low', 'fa fa-star fa-2x low',
    'fa fa-star fa-2x medium', 'fa fa-star fa-2x medium',
    'fa fa-star fa-2x high', 'fa fa-star fa-2x high']


   
   function getValues(e){
     // console.log('SS/MS - questions: ', localthis.state.ssmsquestions)
      localthis.generateJSON();
     /* localthis.setState({
        solution: true // set Button "Lösung" enabled
      }) 
      */
    }   

	  
    return (
      <div>
       { this.state.mode == 'nochnichtbeantwortet' ? 
       <Container>
       <Row>
        <Col sm="12" md={{size:10, offset:1}}>
       

        <ReactFitText>
          <h2>

            <Fab variant="extended" color={this.props.color} aria-label="Toggle" onClick={this.toggle} className={classes.fab} size="small">
              <GroupIcon className={classes.extendedIcon} />
              {this.props.buttonLabel}
            </Fab>

          </h2>
        </ReactFitText>
		
		{ /*
        <Modal isOpen={this.state.modal} toggle={this.toggle} size="lg" className={this.props.className}>
    
          <ModalHeader toggle={this.toggle}> {this.props.surveytype == 1 ? "Starten Sie jetzt Ihren Wissenscheck" : "Starten Sie jetzt Ihre persönliche Umfrage"} </ModalHeader>
          
          <ModalBody>
    */}

          <Card>
          

              { (this.props.type=="text" && this.props.mainquestion != null && this.props.mainquestion!= '')? 
              <CardHeader><h2><strong>{this.props.mainquestion}</strong></h2></CardHeader> 
              : (this.props.type=="video" && this.props.mainclips != null && this.props.mainclips.length > 0) ? 
              <CardHeader><VisualClipComponent clips={this.props.mainclips} /></CardHeader>
              :<CardHeader> <VisualPictureComponent images={this.props.mainpictures} /></CardHeader>
            
            }
            
          </Card>



          {
            this.props.starquestions && this.props.starquestions.length > 0  ? (
            <Card>   
              <CardHeader> {t('questionaire.distributestars')} </CardHeader>
              <CardBody>
             
                {
                  <Container> {
                   this.props.starquestions.map((element, i , arr) => (
                    <div>
                      <Row>
                        <Col xs={12} sm={6} md={6}>
                      {element.question}                      
                      </Col>
                      <Col xs={12} sm={6} md={6}>
                      <Rating
                        stop={5}    
                        initialRating={this.getInitialRating(element.question)}                    
                        onChange={(e) => this.changeRating(element.question, e)}
                        emptySymbol={ this.props.ratingicons ? <img src={this.props.ratingicons.empty} className="icon" />:  emptySymbol}
                        fullSymbol={this.props.ratingicons ? <img src={this.props.ratingicons.full} className="icon" />:  fullSymbol}                          
                      />
                      </Col>
                      </Row>
                      { arr.length -1 === i ? null : <hr/>}
                    </div>
                  ))
                   }
                   </Container>
                  }
              </CardBody>
            </Card>) : null
          }


    {
    this.props.openquestions && this.props.openquestions.length > 0 ? (
            <Card>
              <CardBody>
              
                {
                  (<Container> {                   
                    this.props.openquestions.map( (element, i, arr) =>
                    <div width="100%">
                      <Row>
                    
                        {element.question}<br/>
                        
                        <TextField
                          id="outlined-multiline-flexible"                          
                          label={t('questionaire.answerquestion')}
                          fullWidth={true}
                          multiline
                          rowsMax="4"                          
                          onChange={(e) => this.changeOpenQuestion(element.question, e)}
                          className={classes.textField}
                          margin="normal"
                          variant="outlined"
                        />
                        

                      </Row>
                      { arr.length -1 === i ? null : <hr/>}
                    </div>
                  )}
                  </Container>
                  ) 
                }


              </CardBody>
            </Card>) : null
    }


{
  this.state.ssmsquestions && this.state.ssmsquestions.length > 0 ? (
    <Card>
      <CardHeader> {t('questionaire.ssmssection')} </CardHeader>
      <CardBody>
       { <Container> {
         this.state.ssmsquestions.map( (question, i, arr) =>

         <div>

          {
            question.qtype == "ss" ?  <div><Card>
            <CardHeader> {t('questionaire.ssquestion')} </CardHeader>
            <CardBody>            
            <RadioGroupTrueFalse surveytype={this.props.surveytype} text={question.value} index={question.index} callback={this.ssCallback} />
            </CardBody> </Card> </div>  : <div><Card> <CardHeader> {t('questionaire.question')}: {question.value}</CardHeader>
            <CardBody>
            <MultiSelectView text={question.value} answers={question.answers} index={question.index} callback={this.msCallback} /> </CardBody> </Card></div>
            
          }
          { arr.length -1 === i ? null : <hr/>}
         </div>

        )
         }
        </Container> 
  
       }
      </CardBody>
    </Card>
  ) : null
}

{/*

          </ModalBody>

          <ModalFooter>		  
*/}
    </Col>

    

            {            			                    
             // <Button  color="primary" onClick={ () => {getValues(); } }>Values</Button>	
            }

          <Col sm="10" md={{size:10, offset:1}}>

          {this.state.beantwortung ? <Button  disabled={false} color="primary" onClick={(e) => this.postSurveyAnswerToJoobsterServer(e)}>{t('questionaire.answering')}</Button>	:  <Button  disabled={true} color="primary" onClick={(e) => this.postSurveyAnswerToJoobsterServer(e)}>{t('questionaire.answering')}</Button>    }            

              </Col>          
    {/*
          </ModalFooter>



        </Modal>
    */}

    </Row>
    </Container> :
        <div>
       <Container>
       <Row>
        <Col sm="12" md={{size:10, offset:2}}>          
          <h3>{t('questionaire.thanks')}</h3>
          </Col>
          <Col sm="6" md={{size:20, offset:5}}> 
          {
                 this.props.surveytype == 1 && this.state.isCorrectViewVisible && this.state.ssmsquestions != null && this.state.ssmsquestions.length > 0 ? (
                  this.state.solution ?  <CorrectView buttonLabel={t('questionaire.solution')} disable={false} ssmsquestions={this.state.ssmsquestions} /> : <CorrectView buttonLabel={t('questionaire.solution')} disable={true} ssmsquestions={this.state.ssmsquestions} />
                 ): null
               }      
            </Col>    
              
          </Row>
          </Container>

        </div>
  }
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(Questionaire));




// WEBPACK FOOTER //
// ./src/modules/movie-browser/Questionaire.js